import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {QuestionType} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';

declare var $: any;

@Component({
    selector: 'app-question-parent-variation-one',
    templateUrl: './question-parent-variation-one.component.html',
    styleUrls: ['./question-parent-variation-one.component.scss'],
    standalone: false
})
export class QuestionParentVariationOneComponent implements OnInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Input() showSkip = false;
  @Input() readonly = false;
  @Input() showParent = true;
  @Input() showLabel = true;
  @Output() questionAnswer = new EventEmitter();
  @Input() itemQuestions: Question[] = [];

  QuestionType = QuestionType;
  skip = false;
  parameter: any;
  questionChanged = new Subject<Question>();
  childrenQuestions: Question[] = [];
  constructor(private questionService: GlobalQuestionService) {
    
  }

  ngOnInit(): void {
    this.questionChanged.pipe(debounceTime(1500))
      .subscribe(x => {
        
        if (x) {
          this.saveAnswer(x);
          this.emitEvent();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      try {
        this.parameter = JSON.parse(this.question.parameter);
      } catch (e) { }
      if (this.parameter?.find((p: { parameter: string; value: string }) => p?.parameter === 'show_skip')?.value === '1') {
        this.showSkip = true;
      }
      if (this.question && !this.itemQuestions?.length) {
        this.getChildrenQuestion();
      }
    }
    if (changes?.itemQuestions?.currentValue) {
      this.itemQuestions = changes?.itemQuestions?.currentValue;
    }
    if (changes?.showParent?.currentValue) {
      this.showParent = changes?.showParent?.currentValue;
    }
    if (changes?.showLabel?.currentValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
   // console.log(this.question, this.itemQuestions);
  }

  getChildrenQuestion(): void {
    this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    // parameters.set('question_id', this.question?.cent_aq_question_id.toString());
    // parameters.set('session_id', this.sessionDetails.session_id?.toString());
    // parameters.set('group_id', '0');

    // this.questionService.runCommandNew(`getChildQuestions`, parameters)
    //   .subscribe((items: Question[])  => {
    //     console.log(items)
    //   });
    this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        for (const q of items) {
          if (!this.childrenQuestions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
            this.childrenQuestions.push(Object.assign({}, q));
          }
        }
        this.questionService.spinner(false);
      });
      console.log(this.childrenQuestions);
  }

  onQuestionChange(value: Question): void {
    if (value?.answer) {
      this.questionChanged.next(value);
      for (const q of this.childrenQuestions) {
        if (q?.cent_aq_question_id === value?.cent_aq_question_id) {
          q.answer = value?.answer;
        }
      }
    }
  }

  saveAnswer(question: Question): void {
    this.questionService.saveAnswerOnly(question).subscribe();
  }

  onSkipChange(): void {
    if (this.skip) {
      for (const q of this.childrenQuestions) {
        q.answer = 'skipped';
      }
      this.question.answer = 'skipped';
      this.questionAnswer.emit(this.question);
    } else {
      for (const q of this.childrenQuestions) {
        q.answer = '';
      }
      this.emitEvent();
    }
  }

  emitEvent(): void {
    const excludeUploadList = this.childrenQuestions.filter(q => q.cent_aq_question_type_id !== QuestionType.upload);
    if (excludeUploadList.every(q => q.answer)) {
      this.question.answer = 'Multiple answers';
      this.questionAnswer.emit(this.question);
    }
  }

  ngOnDestroy(): void {
    this.questionChanged.next(undefined as any);
    this.questionChanged.complete();
  }

}
